import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Denounce } from '../../../core/models/denounce.model';

@Component({
	selector: 'app-image-modal',
	templateUrl: './image-modal.component.html',
	styleUrls: ['./image-modal.component.scss'],
})
export class ImageModalComponent implements OnInit {
	denounce: Denounce;
	image: number;

	constructor(
		public dialogRef: MatDialogRef<ImageModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: unknown
	) {
		this.denounce = this.data['denounce'];
		this.image = this.data['image'];
	}

	ngOnInit(): void {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	public next(): void {
		this.image = (this.image + 1) % this.denounce.media.length;
	}

	public prev(): void {
		if (this.image - 1 === -1) {
			this.image = this.denounce.media.length - 1;
		} else {
			this.image = (this.image - 1) % (this.denounce.media.length - 1);
		}
	}

	get imageType(): string {
		const extension = this.denounce.media[this.image].split('.').pop();
		return extension;
	}
}
